import { render } from "./Inquiry.vue?vue&type=template&id=e97d0f94&scoped=true"
import script from "./Inquiry.vue?vue&type=script&lang=js"
export * from "./Inquiry.vue?vue&type=script&lang=js"

import "./Inquiry.vue?vue&type=style&index=0&id=e97d0f94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e97d0f94"]])

export default __exports__